<div class="sp-tool" [class.expanded]="expanded()">
  <!-- Header -->
  <div class="header">
    <div class="header-left">
      <button
        class="sp-btn icon back"
        (click)="onBack()"
        type="button"
        aria-label="Back to tools"
        title="Back"
      >
        <iris-icon name="arrow_back" [size]="iconSizes.SM"></iris-icon>
      </button>
      <div class="title-row">
        <span class="title">Segment Preview</span>
        @if (previewService.segmentDisabled()) {
          <span class="status disabled">Segment Disabled</span>
        } @else if (previewService.sessionActive() && !previewService.paused()) {
          <span class="status recording">
            <span class="status-dot"></span>
            Recording
          </span>
        } @else if (previewService.paused()) {
          <span class="status paused">Paused</span>
        } @else {
          <span class="status idle">Idle</span>
        }
      </div>
    </div>

    <div class="actions">
      @if (!previewService.sessionActive()) {
        <button
          class="sp-btn start"
          (click)="previewService.startSession()"
          type="button"
          [disabled]="previewService.segmentDisabled()"
          [title]="previewService.segmentDisabled() ? 'Segment is globally disabled in configuration' : 'Start recording events'"
        >
          Record
        </button>
      } @else if (previewService.paused()) {
        <button
          class="sp-btn start"
          (click)="previewService.startSession()"
          type="button"
          [disabled]="previewService.segmentDisabled()"
          [title]="previewService.segmentDisabled() ? 'Segment is globally disabled in configuration' : 'Resume recording events'"
        >
          Resume
        </button>
        <button
          class="sp-btn icon danger"
          (click)="previewService.resetSession()"
          type="button"
          aria-label="Clear session"
          title="Clear all events and end session"
        >
          <iris-icon name="delete_outline" [size]="iconSizes.SM"></iris-icon>
        </button>
      } @else {
        <button class="sp-btn pause" (click)="previewService.pauseSession()" type="button">
          Pause
        </button>
      }

      <button
        class="sp-btn icon"
        (click)="toggleExpanded()"
        type="button"
        [attr.aria-label]="expanded() ? 'Collapse panel' : 'Expand panel'"
        [title]="expanded() ? 'Collapse' : 'Expand'"
      >
        <iris-icon
          [name]="expanded() ? 'fullscreen_exit' : 'fullscreen'"
          [size]="iconSizes.SM"
        ></iris-icon>
      </button>
    </div>
  </div>

  <!-- Search + count bar -->
  @if (previewService.eventCount() > 0) {
    <div class="toolbar">
      <div class="search">
        <iris-icon name="search" [size]="iconSizes.SM" colorToken="$color-neutral-60"></iris-icon>
        <input
          class="search-input"
          type="text"
          placeholder="Filter events..."
          [value]="previewService.searchQuery()"
          (input)="onSearchInput($event)"
        />
        @if (previewService.searchQuery()) {
          <button
            class="search-clear"
            (click)="previewService.searchQuery.set('')"
            type="button"
            aria-label="Clear search"
          >
            <iris-icon name="close" [size]="iconSizes.SM" colorToken="$color-neutral-60"></iris-icon>
          </button>
        }
      </div>
      <div class="toolbar-right">
        <span class="count">
          @if (previewService.searchQuery()) {
            {{ previewService.filteredEventCount() }} / {{ previewService.eventCount() }}
          } @else {
            {{ previewService.eventCount() }}
          }
        </span>
        <button
          class="sp-btn export"
          (click)="exportEventsJson()"
          type="button"
          title="Download all captured events as JSON"
        >
          <iris-icon name="download" [size]="iconSizes.SM"></iris-icon>
          Export
        </button>
      </div>
    </div>
  }

  <!-- Event list -->
  <div class="body">
    @if (previewService.eventCount() === 0) {
      <div class="empty">
        @if (previewService.segmentDisabled()) {
          <div class="empty-text">
            <iris-icon name="info" [size]="iconSizes.MD" colorToken="$color-warning-50"></iris-icon>
            <p><strong>Segment is globally disabled</strong></p>
            <p>Recording is unavailable because <code>segmentDisabled</code> is set to <code>true</code> in the app configuration.</p>
          </div>
        } @else if (previewService.sessionActive() && !previewService.paused()) {
          <span class="empty-text">Waiting for events...</span>
        } @else {
          <span class="empty-text">Click <strong>Record</strong> to begin capturing Segment events.</span>
        }
      </div>
    } @else if (previewService.filteredEventCount() === 0) {
      <div class="empty">
        <span class="empty-text">No events matching "{{ previewService.searchQuery() }}"</span>
      </div>
    }

    @for (event of previewService.filteredEvents(); track event.id) {
      <div
        class="sp-event"
        [class.expanded]="expandedEvents().has(event.id)"
        (click)="toggleEvent(event.id)"
      >
        <div class="row">
          <span class="source" [class]="'source-' + event.source">
            {{ event.source }}
          </span>
          <span class="name">{{ event.event }}</span>
          <span class="time">{{ event.timestamp | timeAgo }}</span>
          <iris-icon
            [name]="expandedEvents().has(event.id) ? 'expand_less' : 'expand_more'"
            [size]="iconSizes.SM"
            colorToken="$color-neutral-60"
          ></iris-icon>
        </div>

        @if (expandedEvents().has(event.id)) {
          <div class="details" (click)="$event.stopPropagation()">
            <pre class="json">{{ formatJson(event) }}</pre>
          </div>
        }
      </div>
    }
  </div>
</div>
